import React from 'react';

import { CreativeV5Type } from '../../../../apis/graphql';
import Loader from '../../../Loader';
import type { CreativeBuilderProps } from '../CreativeBuilder';
import { VideoCreativeBuilder } from '../index';

export const wrapWithDraxMagniteCreativeBuilder = (
  component: (props: CreativeBuilderProps) => React.JSX.Element
): ((props: CreativeBuilderProps) => React.JSX.Element) => {
  return (props: CreativeBuilderProps): React.JSX.Element => {
    if (props.loadingCreativeData) return <Loader />;

    const creativeType = props?.creativeData?.getCreativeByIDV5.type;

    if (creativeType === CreativeV5Type.Drax || creativeType === CreativeV5Type.Magnite) {
      return <VideoCreativeBuilder {...props} />;
    }

    return component(props);
  };
};
